import AgendaEmailAddress from "./AgendaEmailAddress";
import AgendaItemResponseStatus from "./AgendaItemResponseStatus";

type AgendaItemAttendeeProps = {
    emailAddress: AgendaEmailAddress;
    status?: AgendaItemResponseStatus;
};

export default class AgendaItemAttendee {
    emailAddress: AgendaEmailAddress;

    status?: AgendaItemResponseStatus;

    constructor({ emailAddress, status }: AgendaItemAttendeeProps) {
        this.emailAddress = emailAddress;
        this.status = status;
    }
}
